"use client";

import type { Variants } from "framer-motion";
import { motion } from "framer-motion";

import RoomCard from "@/components/sections/Rooms/RoomCard";
import type { Room } from "@/payload-types";

export default function RoomList({
  rooms,
}: {
  rooms: Room[];
  title?: string;
  subtitle?: string;
}) {
  const containerVariants: Variants = {
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants: Variants = {
    hidden: { y: -50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  return (
    <div>
      <section id="rooms" className="container mx-auto px-4 pt-0">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {/* Rooms List */}
          <div id="rooms">
            <motion.div
              className="grid grid-cols-1 gap-x-8 gap-y-12 md:grid-cols-2 xl:grid-cols-3"
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              {rooms.map((room, index) => (
                <motion.div
                  key={room.id}
                  variants={itemVariants}
                  custom={index}
                  transition={{ duration: 0.3 }}
                >
                  <RoomCard room={room} />
                </motion.div>
              ))}
            </motion.div>
          </div>
        </motion.div>
      </section>
    </div>
  );
}
